// ============================================
// ADVANCED FILTERING SYSTEM
// Client-side filtering for collections
// ============================================

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.collection-page')) {
    initCollectionFilters();
  }
});

function initCollectionFilters() {
  const productCards = document.querySelectorAll('.product-card');
  const filterButtons = document.querySelectorAll('[data-filter]');
  const sortSelect = document.getElementById('sort-by');
  const searchInput = document.getElementById('collection-search');

  let activeFilters = {
    material: '',
    public: '',
    style: '',
    usage: '',
    search: ''
  };

  // Filter button clicks
  filterButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      const filterType = btn.dataset.filterType;
      const filterValue = btn.dataset.filter;

      // Toggle filter
      if (activeFilters[filterType] === filterValue) {
        activeFilters[filterType] = '';
        btn.classList.remove('active');
      } else {
        // Remove active from siblings
        document.querySelectorAll(`[data-filter-type="${filterType}"]`).forEach(b => {
          b.classList.remove('active');
        });

        activeFilters[filterType] = filterValue;
        btn.classList.add('active');
      }

      applyFilters();
    });
  });

  // Search input
  if (searchInput) {
    searchInput.addEventListener('input', debounce((e) => {
      activeFilters.search = e.target.value.toLowerCase();
      applyFilters();
    }, 300));
  }

  // Sort
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      sortProducts(sortSelect.value, productCards);
    });
  }

  // Clear filters button
  const clearBtn = document.querySelector('.clear-filters');
  if (clearBtn) {
    clearBtn.addEventListener('click', () => {
      activeFilters = {
        material: '',
        public: '',
        style: '',
        usage: '',
        search: ''
      };

      filterButtons.forEach(btn => btn.classList.remove('active'));
      if (searchInput) searchInput.value = '';
      applyFilters();
    });
  }

  function applyFilters() {
    let visibleCount = 0;

    productCards.forEach(card => {
      const tags = (card.dataset.tags || '').toLowerCase().split(',');
      const title = card.querySelector('.product-title')?.textContent.toLowerCase() || '';
      const material = card.querySelector('.product-material')?.textContent.toLowerCase() || '';

      let matches = true;

      // Check material filter
      if (activeFilters.material && !tags.includes(activeFilters.material.toLowerCase())) {
        matches = false;
      }

      // Check public filter
      if (activeFilters.public && !tags.includes(activeFilters.public.toLowerCase())) {
        matches = false;
      }

      // Check style filter
      if (activeFilters.style && !tags.includes(activeFilters.style.toLowerCase())) {
        matches = false;
      }

      // Check usage filter
      if (activeFilters.usage && !tags.includes(activeFilters.usage.toLowerCase())) {
        matches = false;
      }

      // Check search
      if (activeFilters.search) {
        const searchMatch = title.includes(activeFilters.search) ||
                          material.includes(activeFilters.search) ||
                          tags.some(tag => tag.includes(activeFilters.search));
        if (!searchMatch) {
          matches = false;
        }
      }

      // Show/hide product
      if (matches) {
        card.parentElement.style.display = '';
        visibleCount++;
      } else {
        card.parentElement.style.display = 'none';
      }
    });

    // Update results count
    updateResultsCount(visibleCount);
  }

  function updateResultsCount(count) {
    const resultsCountEl = document.querySelector('.collection-results-count');
    if (resultsCountEl) {
      if (count === 0) {
        resultsCountEl.textContent = 'Aucun produit trouvé';
      } else if (count === 1) {
        resultsCountEl.textContent = '1 produit';
      } else {
        resultsCountEl.textContent = `${count} produits`;
      }
    }
  }
}

function sortProducts(sortValue, productCards) {
  const container = productCards[0]?.parentElement?.parentElement;
  if (!container) return;

  const cardsArray = Array.from(productCards).map(card => card.parentElement);

  cardsArray.sort((a, b) => {
    const cardA = a.querySelector('.product-card');
    const cardB = b.querySelector('.product-card');

    switch(sortValue) {
      case 'price-ascending':
        return getPriceValue(cardA) - getPriceValue(cardB);

      case 'price-descending':
        return getPriceValue(cardB) - getPriceValue(cardA);

      case 'title-ascending':
        return getTitle(cardA).localeCompare(getTitle(cardB));

      case 'title-descending':
        return getTitle(cardB).localeCompare(getTitle(cardA));

      default: // manual/featured
        return 0;
    }
  });

  cardsArray.forEach(card => container.appendChild(card));
}

function getPriceValue(card) {
  const priceText = card.querySelector('.price')?.textContent || '0';
  return parseFloat(priceText.replace(/[^0-9,.]/g, '').replace(',', '.')) || 0;
}

function getTitle(card) {
  return card.querySelector('.product-title')?.textContent.trim() || '';
}

function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}
